<template>
  <div class="repairs" v-if="machine">

    <div class="full-modal">
      <b-modal :active.sync="showPhotoModal">
        <!-- <div class="image" v-if="showPhotoModal && editRepair && editRepair.photoUrl" :style="{backgroundImage: `url('${editRepair.photoUrl}')`}"></div> -->
        <div class="image">
          <img v-if="showPhotoModal && editRepair && editRepair.photoUrl" :src="editRepair.photoUrl" />
        </div>
      </b-modal>
    </div>

    <b-modal :active.sync="showRepairModal">
      <div class="box" v-if="editRepair">
        <h4 class="title is-5 no-margin pad-bottom flex">
          <div class="flex-1">{{ editRepair.reportedByUser }}</div>
          <div>{{ editRepair.timestampReported | unixToDateString }}</div>
        </h4>
        <div class="pad-bottom flex">
          <div class="pad-right" v-if="editRepair.urgent">
            <font-awesome-icon class="has-text-danger" icon="exclamation-circle" size="2x" />
          </div>
          <div class="flex-1 is-size-5">
            {{ editRepair.description }}
          </div>
        </div>
        <div class="pad flex">
          <div class="flex-1 text-left"><b-checkbox type="is-danger" v-model="editRepair.urgent">Urgent</b-checkbox></div>
          <div class="flex-1 text-right"><b-checkbox type="is-success" v-model="editRepairFixed">Fixed</b-checkbox></div>
        </div>
        <b-field>
          <b-input type="textarea" placeholder="comments / notes" v-model="editRepair.notes" />
        </b-field>
        <template v-if="this.editRepair.timestampFixed > 0">
          <h4 class="title is-5 no-margin pad-bottom flex">
            <div class="flex-1">{{ editRepair.fixedByUser }}</div>
            <div>{{ editRepair.timestampFixed | unixToDateString }}</div>
          </h4>
        </template>
        <div class="buttons flex">
          <div class="flex-1">
            <button class="button is-info" :class="{'is-loading': submitting}" @click="updateRepair">Update Repair</button>
            <button class="button" @click="closeRepairModal()">Cancel</button>
          </div>
          <div>
            <button v-if="editRepair.photoUrl" class="button" @click="onShowPhoto()">View Photo&nbsp;<fa icon="camera" /></button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="showAddModal">
      <div class="box" v-if="newRepair">
        <h4 class="title is-5 no-margin pad-bottom">Add Repairs</h4>
        <b-field>
          <b-input type="textarea" v-model="newRepair.description" placeholder="description" />
        </b-field>
        <div class="flex">
          <div class="flex-1">
            <b-field>
              <b-checkbox type="is-danger" v-model="newRepair.urgent">Urgent</b-checkbox>
            </b-field>
          </div>
          <div>
            <template v-if="!newRepair.photoDataUrl">
              <label>
                <div class="button">
                  <fa v-if="preparingPhoto" icon="cog" spin />
                  <fa v-else icon="camera" />
                  &nbsp;photo
                </div>
                <input type="file" accept="image/*" @change="onAddRepairPhoto($event, newRepair)" style="position: fixed; top: -99999em" />
              </label>
            </template>
            <template v-else>
              <button class="button is-success" @click="newRepair.photoDataUrl = null"><fa icon="camera" />&nbsp;photo</button>
            </template>
          </div>
        </div>

        <div class="margin center" v-if="uploadingRepair">
          <b>Uploading Photo</b>&nbsp;<i class="fas fa-cog fa-spin"></i>
          <progress class="progress is-info" :value="uploadingRepair.photoUploadProgress" max="100"></progress>
        </div>
        <div class="buttons" v-else>
          <button class="button is-info" :class="{'is-loading': submitting}" @click="submitRepair">Add Repair</button>
          <button class="button" @click="showAddModal = false">Cancel</button>
        </div>
      </div>
    </b-modal>

    <h1 class="title is-4 flex pad no-margin">
      <div class="flex-1 pointer" @click="$router.push(`/view-machine-repairs/${machine._id}`)">
        <font-awesome-icon icon="wrench" />
        Current Repairs
      </div>
      <button v-if="canAdd" class="button is-small" @click="addRepair">
        <font-awesome-icon icon="plus" />
      </button>
    </h1>
    <template v-if="repairs === null">
      <loading />
    </template>
    <template v-else>
      <table class="table" :class="{'is-hoverable': canEdit}">
        <tbody>
          <tr v-for="r in repairs" :key="r._id" @click="selectRepair(r)">
            <td>
              <p class="bold" :class="{'has-text-danger': r.urgent}">
                {{ r.timestampReported | unixToDateString }}
                <fa v-if="r.photoUrl" icon="camera" />
              </p>
              <p>{{ r.reportedByUser }}</p>
            </td>
            <td class="nl">
              <div class="nl">{{ r.description }}</div>
              <div class="comment nl" v-if="r.notes.length">{{ r.notes }}</div>
            </td>
            <td class="td-middle has-text-danger flash">
              <font-awesome-icon v-if="r.urgent" icon="exclamation-circle" size="2x" />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!repairs.length" class="pad text-center has-text-grey-light">
        There are no current repairs
        <br /><br />
      </div>
    </template>

    <template v-if="showFixed">
      <h1 class="title is-4 flex pad no-margin">Fixed Repairs</h1>
      <template v-if="fixedRepairs === null">
        <loading />
      </template>
      <template v-else>
        <table class="table is-hoverable" v-if="fixedRepairs.length">
          <thead>
            <tr>
              <th>Reported</th>
              <th>Fixed</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in fixedRepairs" :key="r._id" @click="selectRepair(r)">
              <td>
                <p class="bold" :class="{'has-text-danger': r.urgent}">
                  {{ r.timestampReported | unixToDateString }}
                  <fa v-if="r.photoUrl" icon="camera" />
                </p>
                <p>{{ r.reportedByUser }}</p>
              </td>
              <td>
                <p class="bold" :class="{'has-text-danger': r.urgent}">{{ r.timestampFixed | unixToDateString }}</p>
                <p>{{ r.fixedByUser }}</p>
              </td>
              <td>
                <div class="nl">{{ r.description }}</div>
                <div class="comment nl" v-if="r.notes.length">{{ r.notes }}</div>
              </td>
              <td class="td-middle has-text-danger flash">
                <font-awesome-icon v-if="r.urgent" icon="exclamation-circle" size="2x" />
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!fixedRepairs.length" class="pad text-center has-text-grey-light">
          There are no fixed repairs
          <br /><br />
        </div>
      </template>
    </template>

  </div>
</template>

<script>
import { RepairsHelper } from '@/utils/repairs'

import firebase from 'firebase/app'
import 'firebase/storage'

export default {
  name: 'Repairs',
  props: {
    machine: { required: true },
    showFixed: { default: false },
    canAdd: { default: true },
    canEdit: { default: true }
  },
  data () {
    return {
      repairs: null,
      fixedRepairs: null,
      selectedRepair: null,
      editRepair: null,
      editRepairFixed: false,
      showRepairModal: false,
      showAddModal: false,
      submitting: false,
      newRepair: null,
      showPhotoModal: false,
      viewPhoto: null,
      preparingPhoto: false,
      uploadingRepair: null
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  watch: {
    machine () {
      this.getRepairs()
    },
    showRepairModal () {
      if (!this.showPhotoModal && !this.showRepairModal) {
        this.closeRepairModal()
      }
    },
    showPhotoModal () {
      this.showRepairModal = !this.showPhotoModal
    }
  },
  created () {
    this.getRepairs()
  },
  methods: {
    selectRepair (r) {
      if (!this.canEdit) return
      this.selectedRepair = r
      this.editRepair = Object.assign(RepairsHelper.getBlankRepair(), r)
      this.editRepairFixed = this.editRepair.timestampFixed > 0
      this.showRepairModal = true
    },
    updateRepair () {
      let update = {}
      let needsUpdate = false
      let nowUrgent = false
      if (this.editRepairFixed && this.selectedRepair.timestampFixed === 0) {
        update.timestampFixed = this.$moment().unix()
        update.fixedByUser = `${this.user.firstName} ${this.user.lastName}`
        update.fixedByUserId = this.user.uid
        needsUpdate = true
      } else if (!this.editRepairFixed && this.selectedRepair.timestampFixed > 0) {
        update.timestampFixed = 0
        update.fixedByUser = null
        update.fixedByUserId = null
        needsUpdate = true
      }

      this.editRepair.notes = this.editRepair.notes.trim()
      if (this.selectedRepair.notes !== this.editRepair.notes) {
        update.notes = this.editRepair.notes
        needsUpdate = true
      }

      if (this.selectedRepair.urgent !== this.editRepair.urgent) {
        update.urgent = this.editRepair.urgent
        needsUpdate = true
        nowUrgent = update.urgent && this.editRepair.timestampFixed === 0
      }

      if (needsUpdate) {
        this.submitting = true
        this.$firestore.collection('machineRepairs')
          .doc(this.selectedRepair._id)
          .update(update)
          .then(resp => {
            if (nowUrgent) {
              RepairsHelper.alertUrgentRepair(this.selectedRepair._id)
            }
            this.$toast.open({ message: 'Repair updated', type: 'is-info' })
            this.closeRepairModal()
          })
          .catch(err => {
            this.$toast.open({ message: 'ERROR could not update repair', type: 'is-danger' })
            this.closeRepairModal()
            console.log('ERROR udating repair', err)
          })
      } else {
        this.closeRepairModal()
      }
    },
    closeRepairModal () {
      this.showRepairModal = false
      this.selectedRepair = null
      this.editRepair = null
      this.submitting = false
    },
    addRepair () {
      if (!this.canAdd) return
      let newRepair = RepairsHelper.getBlankRepair()
      newRepair.photoDataUrl = null
      newRepair.photoPath = null
      newRepair.photoUploadProgress = 0
      this.newRepair = newRepair
      this.showAddModal = true
    },
    async submitRepair () {
      this.newRepair.description = this.newRepair.description.trim()
      if (!this.newRepair.description.length) {
        this.closeAddModal()
        return
      }
      this.submitting = true
      this.newRepair.machine = this.machine.name
      this.newRepair.machineId = this.machine._id
      try {
        if (this.newRepair.photoDataUrl) {
          this.newRepair.photoUrl = await this.uploadRepairPhoto(this.newRepair)
        }

        delete this.newRepair.photoDataUrl
        delete this.newRepair.photoUploadProgress

        let resp = await this.$firestore.collection('machineRepairs')
          .add(this.newRepair)
        if (this.newRepair.urgent) {
          RepairsHelper.alertUrgentRepair(resp.id)
        }
        this.$toast.open({ message: 'Repair Added', type: 'is-info' })
      } catch (err) {
        this.$toast.open({
          message: 'ERROR could not add repair.',
          type: 'is-danger'
        })
        console.log('ERROR adding repair', err)
      }
      this.closeAddModal()
    },
    closeAddModal () {
      this.showAddModal = false
      this.newRepair = null
      this.submitting = false
    },
    getRepairs () {
      this.repairs = null
      this.fixedRepairs = null

      this.unsub('machineRepairs')
      this.unsub('fixedMachineRepairs')

      if (!this.machine) {
        return
      }

      this.subs.machineRepairs = this.$firestore.collection('machineRepairs')
        .where('machineId', '==', this.machine._id)
        .where('timestampFixed', '==', 0)
        .onSnapshot(snapshot => {
          this.repairs = this.$utils.snapshotToArr(snapshot).sort((a, b) => {
            if (a.urgent === b.urgent) {
              return b.timestampReported - a.timestampReported
            } else {
              return Number(b.urgent) - Number(a.urgent)
            }
          })
        })

      if (this.showFixed) {
        this.subs.fixedMachineRepairs = this.$firestore.collection('machineRepairs')
          .where('machineId', '==', this.machine._id)
          .where('timestampFixed', '>', 0)
          .orderBy('timestampFixed', 'desc')
          .onSnapshot(snapshot => {
            this.fixedRepairs = this.$utils.snapshotToArr(snapshot)
          })
      }
    },
    onAddRepairPhoto (e, repair) {
      if (!e.target || !e.target.files || !e.target.files.length) {
        return
      }
      this.preparingPhoto = true
      setTimeout(() => {
        let file = e.target.files[0]
        let fileReader = new FileReader()
        fileReader.onload = (onloadEvent) => {
          this.preparingPhoto = false
          repair.photoName = file.name
          repair.photoDataUrl = onloadEvent.target.result
          repair.uploadProgress = -1
          repair.photoPath = `repair-images/machine-${this.machine._id}-${Number(new Date())}`
        }
        fileReader.readAsDataURL(file)
      }, 300)
    },
    uploadRepairPhoto (repair) {
      return new Promise((resolve, reject) => {
        this.uploadingRepair = repair
        let storageRef = firebase.storage().ref()
        let uploadTask = storageRef.child(repair.photoPath).putString(repair.photoDataUrl, 'data_url')
        repair.photoUploadProgress = 0
        uploadTask.on('state_changed',
          (snapshot) => {
            repair.photoUploadProgress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(0)
          },
          (error) => {
            reject(error.code)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL()
              .then(url => {
                this.uploadingRepair = null
                resolve(url)
              })
          })
      })
    },
    onShowPhoto () {
      this.$store.dispatch('setShowImageUrl', this.editRepair.photoUrl)
      // this.$utils.showImage(this.editRepair.photoUrl)
      // this.showPhotoModal = true
    }
  }

}
</script>

<style>
  .repairs table {
    border-top: solid 2px #ccc;
  }
</style>
